import styled, { css } from "styled-components";

import {
    convertPxToRem,
    handleComponentSize
} from "frontend/components/helpers";

import colors from "core/colors";

import { SHARED_FORM_STYLES } from "core/Form";

import CaretDown from "./images/CaretDown.svg";

const ARROW_SIZE = convertPxToRem({ px: 16 });
const ARROW_MARGIN = convertPxToRem({ px: 8 });

const SIZE_TYPES = {
    XS: css`
        padding-right: calc(
            ${ARROW_SIZE} + ${ARROW_MARGIN} + ${convertPxToRem({ px: 6 })}
        );

        background-position: calc(100% - ${convertPxToRem({ px: 6 })}) center;
        height: ${convertPxToRem({ px: 24 })};
    `,

    SM: css`
        padding-right: calc(
            ${ARROW_SIZE} + ${ARROW_MARGIN} + ${convertPxToRem({ px: 8 })}
        );

        background-position: calc(100% - ${convertPxToRem({ px: 8 })}) center;
        height: ${convertPxToRem({ px: 28 })};
    `,

    MD: css`
        padding-right: calc(
            ${ARROW_SIZE} + ${ARROW_MARGIN} + ${convertPxToRem({ px: 14 })}
        );

        background-position: calc(100% - ${convertPxToRem({ px: 14 })}) 52%;
        height: ${convertPxToRem({ px: 40 })};
    `,

    LG: css`
        padding-right: calc(
            ${ARROW_SIZE} + ${ARROW_MARGIN} + ${convertPxToRem({ px: 16 })}
        );

        background-position: calc(100% - ${convertPxToRem({ px: 16 })}) 52%;
        height: ${convertPxToRem({ px: 48 })};
    `
};

export const Select = styled.select`
    ${SHARED_FORM_STYLES.BASE}

    -webkit-appearance: none; // hides native arrow
    -moz-appearance: none; // hides native arrow
    &::-ms-expand {
        display: none; // hides native arrow in IE11
    }

    font-size: ${convertPxToRem({ px: 16 })};
    line-height: ${convertPxToRem({ px: 19 })};
    color: ${({ textColor }) => textColor};
    width: 100%;
    cursor: pointer;
    background: url(${CaretDown})
        ${({ darkMode }) =>
            darkMode ? colors.secondary.orca : colors.primary.snow}
        no-repeat;

    /* render sizes: */
    ${({ size }) => handleComponentSize({ size, styles: SIZE_TYPES })}
    //

    
    // placeholder:
    &::placeholder {
        ${SHARED_FORM_STYLES.PLACEHOLDER}
    }

    // hover:
    &:hover {
        ${SHARED_FORM_STYLES.HOVER}
    }

    // focus:
    &:focus {
        ${SHARED_FORM_STYLES.FOCUS}
    }

    // disabled:
    &:disabled {
        ${SHARED_FORM_STYLES.DISABLED}
    }

    /* style option for browsers that allow it: */
    option {
        background: ${colors.primary.snow};
        font-size: ${convertPxToRem({ px: 16 })};
        color: ${colors.secondary.orca};
        border-radius: 0;
        padding: ${convertPxToRem({ px: 11 })} 0;

        &:hover {
            color: ${colors.primary.diamond};
            background: ${colors.secondary.orca};
        }

        &:disabled {
            color: ${colors.secondary.oolong};
        }
    }
`;
